module.exports = __webpack_public_path__ + "static/ross_outline-e988f94ac572b53f40c8dfcf3f827bcd.png";